import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Trans } from "react-i18next";
import { withTranslation } from "react-i18next";
import FormHelperText from "@material-ui/core/FormHelperText";
import { connect } from "react-redux";
import { setApplicationProperties } from "../redux/actions/universalActions";

const styles = (theme) => ({
  formControl: {
    marginTop: theme.spacing(1),
  },
});

export class PasswordCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedSnack: false,
      password: "",
      confirmPassword: "",
      emailError: false,
      passwordError: false,
      confirmPasswordError: false,
      emailRegExError: false,
      passwordsDontMatch: false,
      passwordRegexError: false,
      passwordRegex: "",
      passwordRegexErrorMessage: "",
      requiresPasswordChange: false,
      regEx: "",
      passwordTouched: false,
      confirmPasswordTouched: false,
    };
  }

  componentDidMount() {
    this.buildRegexForOrganisation();
    this.buildPasswordErrorMessageForOrganisation();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.applicationProperties != this.props.applicationProperties) {
      this.buildRegexForOrganisation();
      this.buildPasswordErrorMessageForOrganisation();
    }
  }
  render() {
    const { classes, t } = this.props;
    return (
      <div>
        <TextField
          fullWidth
          required
          error={this.state.passwordError || this.state.passwordRegexError}
          disabled={this.props.disableAll}
          type="password"
          id="password"
          label={this.props.t("label_password")}
          onChange={this.handlePasswordChange}
          onBlur={() => this.setState({ passwordTouched: true })}
          value={this.state.password}
          className={classes.formControl}
        />
        {this.state.passwordError && (
          <FormHelperText error id="component-error-text">
            <Trans i18nKey="global_required" />
          </FormHelperText>
        )}
        {this.state.passwordRegexError && (
          <FormHelperText error id="component-error-text">
            {this.state.passwordRegexErrorMessage}
          </FormHelperText>
        )}
        <TextField
          fullWidth
          required
          error={
            this.state.confirmPasswordError || this.state.passwordsDontMatch
          }
          disabled={this.props.disableAll}
          id="password-confirm"
          type="password"
          label={this.props.t("user_admin_confirm_password")}
          onBlur={() => this.setState({ confirmPasswordTouched: true })}
          onChange={this.handleConfirmPasswordChange}
          value={this.state.confirmPassword}
          className={classes.formControl}
        />
        {this.state.confirmPasswordError && (
          <FormHelperText error id="component-error-text">
            <Trans i18nKey="global_required" />
          </FormHelperText>
        )}
        {this.state.passwordsDontMatch && (
          <FormHelperText error id="component-error-text">
            <Trans i18nKey="passwords_must_match" />
          </FormHelperText>
        )}
      </div>
    );
  }

  checkRequiredFieldsAreFilled = () => {
    if (
      !this.state.passwordError &&
      !this.state.confirmPasswordError &&
      !this.state.passwordsDontMatch &&
      !this.state.passwordRegexError
    ) {
      this.props.saveButtonDisable(false);
    } else {
      this.props.saveButtonDisable(true);
    }
  };

  checkPasswordsMatch = () => {
    this.state.password === this.state.confirmPassword
      ? this.setState({ passwordsDontMatch: false }, () => {
          this.checkRequiredFieldsAreFilled();
        })
      : this.setState({ passwordsDontMatch: true }, () => {
          this.checkRequiredFieldsAreFilled();
        });
  };

  buildRegexForOrganisation = () => {
    let regExString = "^(?=.*[a-z])";
    if (
      !this.props.applicationProperties.length &&
      this.props.applicationProperties.length != 0
    ) {
      let passwordStrengthRequirements = JSON.parse(
        this.props.applicationProperties[
          "administration.useradmin.passwordstrengthrequirements"
        ]
      );
      if (passwordStrengthRequirements.useCapitals) {
        regExString += "(?=.*[A-Z])";
      }
      if (passwordStrengthRequirements.useNumbers) {
        regExString += "(?=.*\\d)";
      }
      if (passwordStrengthRequirements.useSpecialCharacters) {
        regExString += "(?=.*[@$!%*?&])";
      }
      if (passwordStrengthRequirements.minimumCharacters != null) {
        regExString +=
          "[A-Za-z\\d@$!%*?&]{" +
          passwordStrengthRequirements.minimumCharacters +
          ",}$";
      }
      this.setState({ regEx: regExString });
    }
  };

  buildPasswordErrorMessageForOrganisation = () => {
    let passwordErrorMessage = "Your password must have a minimum of ";
    if (
      !this.props.applicationProperties.length &&
      this.props.applicationProperties.length != 0
    ) {
      let passwordStrengthRequirements = JSON.parse(
        this.props.applicationProperties[
          "administration.useradmin.passwordstrengthrequirements"
        ]
      );
      if (passwordStrengthRequirements.minimumCharacters != null) {
        passwordErrorMessage +=
          passwordStrengthRequirements.minimumCharacters + " characters, ";
      }
      if (passwordStrengthRequirements.useCapitals) {
        passwordErrorMessage += "one capital letter, ";
      }
      if (passwordStrengthRequirements.useNumbers) {
        passwordErrorMessage += "one number ";
      }
      if (passwordStrengthRequirements.useSpecialCharacters) {
        passwordErrorMessage += " and one special character i.e. $%^&*.";
      }
      this.setState({ passwordRegexErrorMessage: passwordErrorMessage });
    }
  };

  handlePasswordChange = (e) => {
    this.setState({ passwordTouched: true });
    let passwordRegularExpression = new RegExp(this.state.regEx);

    passwordRegularExpression.test(e.target.value)
      ? e.target.value === ""
        ? this.setState(
            {
              passwordError: true,
              password: e.target.value,
              passwordRegexError: false,
            },
            () => {
              this.checkRequiredFieldsAreFilled();
              this.checkPasswordsMatch();
            }
          )
        : this.setState(
            {
              passwordError: false,
              password: e.target.value,
              passwordRegexError: false,
            },
            () => {
              // this.props.stateUpdated(this.state);
              this.checkRequiredFieldsAreFilled();
              this.checkPasswordsMatch();
            }
          )
      : this.setState(
          { passwordRegexError: true, password: e.target.value },
          () => {
            this.checkPasswordsMatch();
          }
        );
  };

  handleConfirmPasswordChange = (e) => {
    this.setState({ confirmPasswordTouched: true });
    this.props.updatePassword(e.target.value);
    this.state.password === e.target.value
      ? e.target.value === ""
        ? this.setState(
            {
              confirmPasswordError: true,
              confirmPassword: e.target.value,
              passwordsDontMatch: false,
            },
            () => {
              this.checkRequiredFieldsAreFilled();
            }
          )
        : this.setState(
            {
              confirmPasswordError: false,
              confirmPassword: e.target.value,
              passwordsDontMatch: false,
            },
            () => {
              // this.props.stateUpdated(this.state);
              this.checkRequiredFieldsAreFilled();
            }
          )
      : this.setState(
          {
            passwordsDontMatch: true,
            confirmPassword: e.target.value,
          },

          () => {
            this.checkRequiredFieldsAreFilled();
          }
        );
  };

  handleSnackClose = () => {
    this.setState({ updatedSnack: false });
  };
}
const mapStateToProps = (state) => ({
  applicationProperties: state.setting.applicationProperties,
});

const mapDispatchToProps = {
  setApplicationProperties,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(PasswordCheck)));
